import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getDirections,
  getEventTypes,
  getGames,
  getPlatforms,
  getResponsible,
  getVersions,
  getFormChannels,
  getClassTags,
  getTechTags,
  getTypeTags,
} from '../store/actions/formCollections';

import { directions } from '../constants';

const useDynamicLoader = (
  { direction, eventType, game, platform },
  operation,
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDirections('grid'));
  }, [dispatch]);

  useEffect(() => {
    if (!direction) {
      return;
    }
    dispatch(getEventTypes(direction));
  }, [direction, dispatch]);

  useEffect(() => {
    if (!direction || !eventType || !operation) {
      return;
    }
    dispatch(getGames(direction, eventType, operation));
  }, [direction, eventType, operation, dispatch]);

  useEffect(() => {
    if (!direction || !eventType || !game) {
      return;
    }
    dispatch(getPlatforms(direction, eventType, game));
  }, [direction, eventType, game, dispatch]);

  useEffect(() => {
    if (!game || direction === directions.INCEDENT) {
      return;
    }
    dispatch(getResponsible(direction, game));
  }, [direction, game, dispatch]);

  useEffect(() => {
    if (!direction || !game || !platform) {
      return;
    }
    dispatch(getVersions(direction, game, platform));
  }, [direction, game, platform, dispatch]);

  useEffect(() => {
    if (direction !== directions.CRM) {
      return;
    }
    dispatch(getFormChannels(direction));
  }, [direction, dispatch]);

  useEffect(() => {
    if (direction !== directions.INCEDENT) {
      return;
    }
    dispatch(getClassTags(direction));
    dispatch(getTechTags(direction));
    dispatch(getTypeTags(direction));
  }, [direction, dispatch]);
};

export default useDynamicLoader;
